module["exports"] = [
  "N",
  "E",
  "S",
  "W",
  "NE",
  "NW",
  "SE",
  "SW"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/en/address/direction_abbr.js
// module id = 2564
// module chunks = 1610